import "./src/shared-components/styles/main.scss";
import "./src/shared-components/wordpress/index.tsx";
